import React from "react";
import { observer } from "mobx-react-lite";

import { themeStore } from "@/stores/theme";
import { CapsulesPanel } from "@/components/Capsules";
import TextTrigger, { TextTriggerProps } from "@/components/Triggers/TextTrigger";

const CapsuleGallery: React.FC<{ words: string[] } & Omit<TextTriggerProps, "popupGenerator">> = ({
  words,
  mt,
  w,
  textH,
  ...others
}) => {
  const { panelBg } = themeStore.styles;

  return (
    <TextTrigger
      mt={mt ?? "16px"}
      w={w ?? "100%"}
      textH={textH ?? 24}
      popupGenerator={(value, setValue) => (
        <CapsulesPanel
          w="200px"
          py="16px"
          px="8px"
          bg={panelBg}
          words={words}
          callbackFn={(value) => async () => setValue(value)}
          focusingWord={value}
        />
      )}
      {...others}
    />
  );
};

export default observer(CapsuleGallery);
